module.exports = __webpack_public_path__ + "img/f-2.e2e326f1.jpg";